import React from 'react';
import { KeyboardDatePicker, MuiPickersUtilsProvider, KeyboardDatePickerProps } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { TextFieldProps } from '@material-ui/core';
import { ApariTextField } from 'components/common/ui';
import clsx from 'clsx';
import styles from './styles';
import { DateTimeServices, GlobalServices } from 'utils';
import { DATE_FORMAT } from 'constants/index';
import { FormikContextType, getIn } from 'formik';

const BasicTextComponent = (props: TextFieldProps) => {
    const { disabled, error, helperText, ...rest } = props;
    const classes = styles();

    return (
        <ApariTextField
            error={error}
            helperText={helperText}
            fullWidth
            noShrinkClass
            disabled={disabled}
            classes={{
                root: clsx(classes.root, disabled && classes.disableHover)
            }}
            onChange={e => {
                e.preventDefault();
            }}
            {...rest}
            variant="standard"
            color="primary"
        />
    );
};

type Props = Partial<KeyboardDatePickerProps> & {
    control: string;
    formik: FormikContextType<any>;
};

export const MTDFormDateField: React.FC<Props> = ({ format, disableToolbar = true, TextFieldComponent, control, formik, ...props }) => {
    const classes = styles();

    const getDateFormat = () => {
        return GlobalServices.isEmpty(format) ? DATE_FORMAT.DD_MM_YYYY : format;
    };

    const handleDateChange = (date: Date | null) => {
        if (GlobalServices.isDefined(date) && DateTimeServices.isValid(date)) {
            formik.setFieldValue(control, DateTimeServices.getDateInGivenFormat(date, DATE_FORMAT.YYYY_MM_DD));
        } else {
            formik.setFieldValue(control, date);
        }
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                name={control}
                autoOk
                disableToolbar={disableToolbar}
                margin="dense"
                format={getDateFormat()}
                value={getIn(formik.values, control)}
                error={getIn(formik.touched, control) && Boolean(getIn(formik.errors, control))}
                helperText={getIn(formik.touched, control) && getIn(formik.errors, control)}
                onChange={handleDateChange}
                placeholder={DATE_FORMAT.DATE_OF_BIRTH_FORMAT}
                className={clsx(classes.pickerRoot)}
                InputProps={{
                    className: clsx(classes.textFieldRoot)
                }}
                InputLabelProps={{
                    shrink: true
                }}
                TextFieldComponent={TextFieldComponent || BasicTextComponent}
                KeyboardButtonProps={{
                    'aria-label': 'change date'
                }}
                {...props}
            />
        </MuiPickersUtilsProvider>
    );
};

export default MTDFormDateField;
